import React from 'react';
import { SocialFeed } from '../../../components/social/SocialFeed';

export default function FeedPage() {
  return (
    <div className="space-y-6 pb-20 lg:pb-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Feed Social
        </h1>
        <p className="text-gray-600">
          Acompanhe as conquistas e celebre o sucesso dos seus amigos e colegas!
        </p>
      </div>

      {/* Feed */}
      <SocialFeed />
    </div>
  );
}
